import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ReactQuill from "react-quill";
import { ToastContainer, toast } from "react-toastify";
import {
  fetchHomeAboutSLRaheja,
  editHomeAboutSLRaheja,
  updateHomeAboutSLRaheja,
  trashHomeAboutSLRaheja,
} from "../../Adapters/ApiAdapter";
import { baseImage_path, baseUrl } from "../../variables/Variables";
import CKEditorField from "../../components/CKEditorField";

const HomeAboutSLRaheja = () => {
  const [data, setData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImg, setMainImg] = useState(null);
  const [rightImg, setRightImg] = useState(null);

  const loadData = async () => {
    try {
      const res = await fetchHomeAboutSLRaheja();
      setData(res.data);
    } catch {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleEdit = async () => {
    try {
      const res = await editHomeAboutSLRaheja(data.id);
      setEditData(res.data);
    } catch {
      toast.error("Failed to load edit data.");
    }
  };

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("title", editData.title);
    formData.append("left_heading", editData.left_heading);
    formData.append("left_content", editData.left_content);
    formData.append("patient_review", editData.patient_review);
    formData.append("right_heading", editData.right_heading);
    formData.append("right_content", editData.right_content);
    if (mainImg) formData.append("main_img", mainImg);
    if (rightImg) formData.append("right_img", rightImg);

    try {
      await updateHomeAboutSLRaheja(editData.id, formData);
      toast.success("Updated successfully.");
      setEditData(null);
      loadData();
    } catch {
      toast.error("Failed to update.");
    }
  };

  const handleTrash = async () => {
    try {
      await trashHomeAboutSLRaheja(data.id);
      toast.success("Deleted successfully.");
      loadData();
    } catch {
      toast.error("Failed to delete.");
    }
  };

  return (
    <Box m={3}>
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Home About S.L. Raheja Section
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : data ? (
        <Box>
          <Typography variant="h6">{data.title}</Typography>
          <Typography>{data.left_heading}</Typography>
          <Typography>{data.left_content}</Typography>
          <img src={`${baseImage_path}/${data.main_img}`} alt="Main" width="150" />
          <Typography>{data.patient_review}</Typography>
          <Typography>{data.right_heading}</Typography>
          <div dangerouslySetInnerHTML={{ __html: data.right_content }} />
          <img src={`${baseImage_path}/${data.right_img}`} alt="Right" width="150" />

          <Box mt={2}>
            <Button variant="contained" onClick={handleEdit}>
              Edit
            </Button>
            {/* <Button variant="contained" color="error" onClick={handleTrash} sx={{ ml: 2 }}>
              Trash
            </Button> */}
          </Box>
        </Box>
      ) : (
        <Typography>No data available.</Typography>
      )}

      {editData && (
        <Dialog open onClose={() => setEditData(null)} maxWidth="sm" fullWidth>
          <DialogTitle>Edit About Section</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Title"
              value={editData.title}
              onChange={(e) => setEditData({ ...editData, title: e.target.value })}
              margin="dense"
            />
            <TextField
              fullWidth
              label="Left Heading"
              value={editData.left_heading}
              onChange={(e) => setEditData({ ...editData, left_heading: e.target.value })}
              margin="dense"
            />
            <TextField
              fullWidth
              label="Left Content"
              multiline
              rows={3}
              value={editData.left_content}
              onChange={(e) => setEditData({ ...editData, left_content: e.target.value })}
              margin="dense"
            />
            <TextField
              fullWidth
              label="Patient Review"
              value={editData.patient_review}
              onChange={(e) => setEditData({ ...editData, patient_review: e.target.value })}
              margin="dense"
            />
            <TextField
              fullWidth
              label="Right Heading"
              value={editData.right_heading}
              onChange={(e) => setEditData({ ...editData, right_heading: e.target.value })}
              margin="dense"
            />
            <Typography mt={2}>Right Content</Typography>
            {/* <ReactQuill
              value={editData.right_content}
              onChange={(value) => setEditData({ ...editData, right_content: value })}
            /> */}
            <CKEditorField
            value={editData.right_content}
            onChange={(data) => setEditData((prev) => ({ ...prev, right_content: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=home-aboutus`}
          />
            <Box mt={2}>
              <Typography>Update Main Image</Typography>
              <input type="file" onChange={(e) => setMainImg(e.target.files[0])} />
              <Typography>Update Right Image</Typography>
              <input type="file" onChange={(e) => setRightImg(e.target.files[0])} />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditData(null)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default HomeAboutSLRaheja;